<template>
    <div class="safety-right-image h-full w-full relative bg-center bg-no-repeat bg-cover">
        <ul class="image-annotations absolute w-full h-full left-0 top-0">
            <li class="annotations--front w-full block absolute leading-spc2 font-semibold text-dark_gray text-14 h-spc12">
                <span class="absolute">Front-Impact Protection</span>
            </li>
            <li class="annotations--top w-full block absolute leading-spc2 font-semibold text-dark_gray text-14 h-spc13">
                <span class="absolute">Side-Impact Protection</span>
            </li>
            <li class="annotations--bottom w-full block absolute leading-spc2 font-semibold text-dark_gray text-14 h-spc14">
                <span class="absolute">Very Low Rollover Risk</span>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "SafetyRightAnnotations"
    }
</script>

<style scoped>

</style>